import { AppShell, Avatar, Divider, Flex, Text, useMantineTheme } from "@mantine/core";
import LogoElsa from "../../static/svg/logo-elsa-bold.svg?react";
import { useAuth } from "../../context";
import { User } from "./_user";

export const Header = () => {
  const { user } = useAuth();
  const theme = useMantineTheme();

  return (
    <AppShell.Header h={80} p="md" withBorder>
      <Flex justify="space-between" align="center" h="100%">
        <Flex w={200} justify="start">
          {user ? (
            <Avatar src={user.logo} radius="xl" size={40} component="a" href="/inicio" />
          ) : null}
        </Flex>

        <Flex justify="center" align="center" flex={1}>
          <LogoElsa
            fill={theme.colors["genderlab-red"][4]}
            height={80}
            onClick={() => (window.location.href = "/inicio")}
            style={{ cursor: "pointer" }}
          />
        </Flex>

        <Flex w={200} justify="end" align="center" gap="md">
          <Text size="md" component="a" href="/inicio" style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
            Mis Cursos
          </Text>
          <Divider size="sm" orientation="vertical" />
          <User />
        </Flex>
      </Flex>
    </AppShell.Header>
  );
};
